import * as React from 'react';
import { SVGProps } from 'react';

const IconAllDoneSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1.414 6.5 0 7.914l4.243 4.746 1.404-1.499L1.414 6.5zm10.324-1.838-3.35 3.574-1.453-1.6 3.389-3.389 1.414 1.415z" />
    <path d="m4.243 7.914 1.312-1.312 2.93 3.228L14.6 3.281l1.38 1.38-7.495 7.999-4.242-4.746z" />
  </svg>
);
export default IconAllDoneSizeS;
